import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import apiClient from "../utils/api";

const MailIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
    <polyline points="22,6 12,13 2,6"></polyline>
  </svg>
);

const LockIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
    <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
  </svg>
);

const UserIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
    <circle cx="12" cy="7" r="4"></circle>
  </svg>
);

const Login = ({ onLogin }) => {
  const [credentials, setCredentials] = useState({
    username: "",
    password: "",
  });

  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    try {
      const response = await apiClient.request("/auth/login", {
        method: "POST",
        body: JSON.stringify(credentials),
      });

      const userData = {
        authenticated: true,
        token: response.access_token,
        role: response.role,
        username: response.username,
        agent_id: response.agent_id,
        tenant_id: response.tenant_id,
        assigned_agents: response.assigned_agents || []
      };
      sessionStorage.setItem("user", JSON.stringify(userData));

      onLogin();
      navigate("/admin");
    } catch (err) {
      setError(err?.detail || err?.message || "Invalid credentials");
    }
  };

  return (
    <>
      <style>{`
        body {
          margin: 0;
          font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
        }
        .split-layout {
          display: flex;
          height: 100vh;
          width: 100%;
        }
        .left-panel {
          flex: 1;
          background: url('/login.png') no-repeat center center;
          background-size: cover;
          color: white;
          padding: 60px;
          display: flex;
          flex-direction: column;
          justify-content: center;
        }
        .right-panel {
          width: 520px;
          flex-shrink: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #f9f9f9;
        }
        .now-live-badge {
          display: inline-flex;
          align-items: center;
          background: rgba(255,255,255,0.2);
          padding: 6px 14px;
          border-radius: 20px;
          font-size: 0.85rem;
          font-weight: 500;
          margin-bottom: 30px;
          width: fit-content;
        }
        .dot {
          width: 6px;
          height: 6px;
          background-color: white;
          border-radius: 50%;
          margin-right: 8px;
        }
        .hero-title {
          font-size: 3.5rem;
          font-weight: 800;
          line-height: 1.1;
          margin-bottom: 20px;
        }
        .hero-desc {
          font-size: 1.1rem;
          line-height: 1.5;
          margin-bottom: 40px;
          color: rgba(255,255,255,0.8);
          max-width: 450px;
        }
        .feature-list {
          display: flex;
          flex-direction: column;
          gap: 15px;
        }
        .feature-item {
          display: flex;
          align-items: center;
          font-weight: 500;
          font-size: 1rem;
        }
        
        .login-box {
          background: white;
          padding: 50px;
          border-radius: 20px;
          box-shadow: 0 10px 40px rgba(0,0,0,0.05);
          width: 100%;
          max-width: 450px;
        }
        .brand {
          display: flex;
          align-items: center;
          gap: 12px;
          font-weight: 700;
          font-size: 1.2rem;
          margin-bottom: 30px;
        }
        .logo-icon {
          width: 32px;
          height: 32px;
          background: #111;
          color: white;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 8px;
          font-weight: 700;
          font-size: 1.1rem;
        }
        .form-title {
          font-size: 1.8rem;
          font-weight: 700;
          margin-bottom: 10px;
          color: #111;
        }
        .form-subtitle {
          color: #666;
          font-size: 0.95rem;
          margin-bottom: 30px;
        }
        .input-group {
          margin-bottom: 20px;
        }
        .input-label {
          display: block;
          font-size: 0.85rem;
          font-weight: 600;
          margin-bottom: 8px;
          color: #333;
        }
        .input-wrapper {
          position: relative;
          display: flex;
          align-items: center;
        }
        .input-icon {
          position: absolute;
          left: 15px;
          color: #999;
          display: flex;
          align-items: center;
        }
        .input-field {
          width: 100%;
          padding: 12px 15px 12px 45px;
          border: 1px solid #e0e0e0;
          border-radius: 10px;
          font-size: 0.95rem;
          outline: none;
          transition: all 0.2s;
          box-sizing: border-box;
        }
        .input-field:focus {
          border-color: #333;
          box-shadow: 0 0 0 3px rgba(0,0,0,0.05);
        }
        .submit-btn {
          width: 100%;
          padding: 14px;
          background: #111;
          color: white;
          border: none;
          border-radius: 10px;
          font-size: 1rem;
          font-weight: 600;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
          transition: background 0.2s;
          margin-top: 10px;
        }
        .submit-btn:hover {
          background: #333;
        }
        .divider {
          display: flex;
          align-items: center;
          margin: 25px 0;
          color: #aaa;
          font-size: 0.8rem;
        }
        .divider::before, .divider::after {
          content: "";
          flex: 1;
          border-bottom: 1px solid #eee;
        }
        .divider::before { margin-right: 15px; }
        .divider::after { margin-left: 15px; }
        
        .error-text {
          color: #e53e3e;
          font-size: 0.85rem;
          margin-bottom: 15px;
          text-align: center;
        }

        .toggle-mode-btn {
          background: none;
          border: none;
          color: #00193b;
          font-weight: 600;
          cursor: pointer;
          padding: 0;
          font-size: 0.9rem;
          transition: color 0.15s ease;
        }
        .toggle-mode-btn:hover {
          color: #639cb8;
        }

        @media (max-width: 900px) {
          .left-panel {
            display: none;
          }
          .right-panel {
            width: 100%;
            background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
          }
        }
      `}</style>

      <div className="split-layout">
        <div className="left-panel">
        </div>

        <div className="right-panel">
          <div className="login-box">
            <h2 className="form-title">Sign in to your account</h2>
            <p className="form-subtitle" style={{ marginBottom: "20px" }}>
              Manage your custom AI assistant workspace
            </p>

            <form onSubmit={handleLogin}>
              <div className="input-group">
                <label className="input-label">Username</label>
                <div className="input-wrapper">
                  <span className="input-icon"><UserIcon /></span>
                  <input
                    type="text"
                    placeholder="Enter your username"
                    className="input-field"
                    required
                    value={credentials.username}
                    onChange={(e) => setCredentials({ ...credentials, username: e.target.value })}
                  />
                </div>
              </div>

              <div className="input-group">
                <label className="input-label">Password</label>
                <div className="input-wrapper">
                  <span className="input-icon"><LockIcon /></span>
                  <input
                    type="password"
                    placeholder="Enter your password"
                    className="input-field"
                    required
                    value={credentials.password}
                    onChange={(e) => setCredentials({ ...credentials, password: e.target.value })}
                  />
                </div>
              </div>

              {error && <div className="error-text">{error}</div>}

              <button type="submit" className="submit-btn">
                Login
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="5" y1="12" x2="19" y2="12"></line>
                  <polyline points="12 5 19 12 12 19"></polyline>
                </svg>
              </button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
